'use client'

import { CheckCircle2 } from 'lucide-react'

type Tone = 'green' | 'orange' | 'purple'

const toneStyles: Record<Tone, { iconWrap: string; icon: string }> = {
  green: {
    iconWrap: 'bg-emerald-50',
    icon: 'text-emerald-600',
  },
  orange: {
    iconWrap: 'bg-orange-50',
    icon: 'text-orange-600',
  },
  purple: {
    iconWrap: 'bg-purple-50',
    icon: 'text-purple-600',
  },
}

export default function VerifiedCard({
  title,
  subtitle,
  value,
  tone = 'green',
}: {
  title: string
  subtitle: string
  value: string
  tone?: Tone
}) {
  const t = toneStyles[tone]

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {/* keep box size unchanged */}
        <div className={`size-12 rounded-xl flex items-center justify-center ${t.iconWrap}`}>
          {/* ONLY circle + tick enlarged */}
          <CheckCircle2 className={t.icon} size={30} />
        </div>

        <div className="flex flex-col">
          <p className="text-slate-800 font-semibold">{title}</p>
          <p className="text-slate-500 text-sm">{subtitle}</p>
        </div>
      </div>

      <span className="text-3xl font-extrabold text-slate-800">{value}</span>
    </div>
  )
}
